<template>
    <div>
        <!--搜索表单-->
        <div class="common-seach-wrap">
            <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
                <el-form-item label="类型">
                    <el-select v-model="formInline.type" placeholder="请选择" clearable>
                        <el-option v-for="(item,index) in type" :key="index" :label="item.name" :value="item.value"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="添加日期">
                <div class="block">
                    <span class="demonstration"></span>
                    <el-date-picker v-model="formInline.date" clearable type="date"  value-format="yyyy-MM-dd" placeholder="选择日期">
                    </el-date-picker>
                </div>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
                </el-form-item>
            </el-form>
        </div>

        <!--内容-->
        <div class="table-wrap">
            <el-table :data="listData" style="width: 100%" v-loading="loading">
                <el-table-column prop="id" label="序号" width="60"></el-table-column>
                <el-table-column prop="type" label="类型" width="80"></el-table-column>
                <el-table-column prop="date" label="日期" width="150">
                    <template slot-scope="scope">
                        <p>{{ scope.row.date }}</p>
                        <p class="gray9" v-if="scope.row.date_str !=''">{{ scope.row.date_str }}前</p>
                    </template>
                </el-table-column>
                <el-table-column prop="name" label="名称"></el-table-column>
            </el-table>
            <div style="margin-top: 20px">
                <el-button type="primary" icon="el-icon-refresh-right" @click="onSubmit()">刷新</el-button>
            </div>
        </div>
    </div>
</template>

<script>
    import LogApi from '@/api/log.js';
    export default {
        data() {
            return {
                /*分类*/
                listData: [],
                /*是否加载完成*/
                loading: true,
                formInline: {
                    type: 'info',
                    date: '',
                },
                type: [
                    {value: 'info', name: '日志信息'},
                    {value: 'error', name: '错误信息'},
                ]
            }
        },
        created() {
            /*获取列表*/
            this.getTableList();
        },
        methods: {
            /*获取列表*/
            getTableList() {
                let self = this;
                let Params = self.formInline;
                LogApi.getList(Params, true)
                .then(data => {
                    self.loading = false;
                    self.listData = data.data;
                })
                .catch(error => {
                    self.loading = false;
                });
            },

            /*搜索查询*/
            onSubmit() {
                this.loading = true;
                this.getTableList();
            },

        }
    }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/log/log/index.vue